import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HomeService } from 'src/home/home.service';
import { ChangeDetectorRef } from '@angular/core';
import Swal from 'sweetalert2';
import { UsersService } from '../services/users.service';


@Component({
  selector: 'app-user-change-role-modal',
  templateUrl: './user-change-role-modal.component.html',
  styleUrls: ['./user-change-role-modal.component.css']
})
export class UserChangeRoleModalComponent {
  roles: string[] = ['ROLE_ADMIN', 'ROLE_CRM', 'ROLE_CONSULTANT'];
  userId: string = '';
  selectedRole: string = '';
  userForm: FormGroup;


  public isLoading: boolean = false;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<UserChangeRoleModalComponent>,
    private usersService: UsersService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,

  ) {
    this.userForm = this.fb.group({
      role: [data.currentRole || '', Validators.required]
    });
  }


  handleChangeRole(): void {
    const user = this.data.user;
    user.role = this.selectedRole;
    this.usersService.changeUserRole(user).subscribe(
      (response) => {
        this.isLoading = false;
        Swal.fire({
          text: 'Cambio de rol realizado exitosamente',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#4caf50'
        }).then((res) => {
          if (res.isConfirmed) {
            this.usersService.rolEmitter.emit('refresh')

          }
        })

        this.changeDetectorRef.detectChanges();

      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          text: 'Error al cambiar el rol',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33'
        });
        console.error('Error al actualizar el rol:', error);
      }
    );

  }

  assingRole(role: any) {
    this.selectedRole = role.target.value
  }

  closeModal(): void {
    this.dialogRef.close();
  }

}
